import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { AccountService } from 'shared/services/account.service';

import { AccountPasswordComponent } from '../account-password/account-password.component';

@Component({
  selector: 'app-account-password-modal',
  templateUrl: './account-password-modal.component.html',
  styleUrls: ['./account-password-modal.component.scss']
})
export class AccountPasswordModalComponent {
  @ViewChild(AccountPasswordComponent) accountPasswordComponent!: AccountPasswordComponent;

  get form(): UntypedFormGroup {
    return this.accountPasswordComponent.form;
  }

  constructor(
    private accountService: AccountService
  ) {}

  onSubmit(): Observable<any> {
    return this.accountService.updateAccountPassword(this.form.value);
  }
}
